<template>
  <div id="tutorialUIContainer" v-show="isShow">
    <div
      class="tutorial__click"
      v-on:touchmove="ignoreTouch"
      @click="next"
      v-show="slide == 3"
    ></div>
    <div id="tutorialUI">
      <div class="tutorial__bg"></div>
      <div class="tutorial__body">
        <div class="tutorial__skip" @click="skip">
          SKIP
        </div>
        <div class="tutorialTitle bold">チュートリアル</div>
        <div class="tutorialStepper">
          <div class="tutorialStepper__step" :class="{ current: slide == 1 }">
            1
          </div>
          <div class="tutorialStepper__line"></div>
          <div class="tutorialStepper__step" :class="{ current: slide == 2 }">
            2
          </div>
          <div class="tutorialStepper__line"></div>
          <div class="tutorialStepper__step" :class="{ current: slide == 3 }">
            3
          </div>
        </div>
        <transition name="fadeUp">
          <div class="tutorialDmyOK" v-if="slide == 3">
            <div class="tutorialDmyOK__button">
              <div class="buttonMini buttonMini--80 button--primaryColor">
                OK
              </div>
            </div>
            <div class="tutorialDmyOK__fukidashi">
              <img src="../../assets/tutorial/save.png" alt="" />
            </div>
          </div>
        </transition>

        <div
          class="tutorialSlide"
          v-on:touchmove="ignoreTouch"
          v-show="slide == 1"
        >
          <div class="tutorialSlide__text tutorialSlide__text--1 textShadow">
            <span
              v-for="(t, index) in '拡大縮小できます。'"
              :key="index"
              v-text="t"
              class="spanLetters"
            />
          </div>
          <div class="tutorialSlide__figure">
            <div
              :class="{ 'tutorialSlide__scaleFig--2': scaleFigLarge }"
              class="tutorialSlide__scaleFig"
            ></div>
          </div>
          <div
            class="tutorialSlide__next button button--dark"
            @click="nextSlide"
          >
            次へ
          </div>
        </div>
        <transition v-on:enter="enterFx(2)">
          <div
            class="tutorialSlide"
            v-on:touchmove="ignoreTouch"
            v-show="slide == 2"
          >
            <div class="tutorialSlide__text tutorialSlide__text--2 textShadow">
              <span
                v-for="(t, index) in '2本指で画面を移動できます。'"
                :key="index"
                v-text="t"
                class="spanLetters"
              />
            </div>
            <div
              ref="figScroll"
              class="tutorialSlide__figure tutorialSlide__figure--2"
            >
              <img src="../../assets/ui/hand-move.png" alt="" />
            </div>
            <div
              class="tutorialSlide__next button button--dark"
              @click="nextSlide"
            >
              次へ
            </div>
          </div>
        </transition>
        <div
          class="tutorialSlide"
          v-on:touchmove="ignoreTouch"
          @click="next"
          v-show="slide == 3"
        >
          <div
            class="tutorialSlide__text tutorialSlide__text--start textShadow"
            :style="{ top: `${slide3Center}px` }"
          >
            <span
              v-for="(t, index) in '画面をタップしてスタート'"
              :key="index"
              v-text="t"
              class="spanLetters spanLetters--noLast"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as modeTypes from "../../store/modules/mode/types";
import * as tutorialTypes from "../../store/modules/tutorial/types";
import * as StoreUtil from "../../util/StoreUtil";
import { animOffset, animScale, spanAnim } from "../../util/TweenUtil";
import { TweenMax, Expo, Power2 } from "gsap";

export default {
  name: "TutorialUI",
  data() {
    return {
      scaleFigLarge: false,
      nextOK2: false
    };
  },
  computed: {
    slide: {
      get() {
        return this.$store.state.tutorial.slide;
      },
      set(val) {
        this.$store.dispatch(
          tutorialTypes.namespace + tutorialTypes.SET_SLIDE,
          val
        );
      }
    },
    slide3Center() {
      return (window.innerHeight - 170) * 0.5;
    },
    scale() {
      return this.$store.state.canvas.scale;
    },
    offset() {
      return this.$store.state.canvas.offset;
    },
    isShow() {
      return StoreUtil.isModeTutorial();
    },
    mode() {
      return this.$store.state.mode.mode;
    }
  },
  watch: {
    mode(value) {
      if (this.mode == modeTypes.MODE_TUTORIAL) {
        this.init();
        this.showPinch();
      }
    },
    slide(val) {
      if (val === 2) {
        this.showScroll();
      } else if (val === 3) {
        this.showTools();
      }
    }
  },
  methods: {
    enterFx(num) {
      console.log("enterFx num", num);
    },
    init() {
      this.slide = 1;
    },
    next() {
      this.$store.dispatch(
        modeTypes.namespace + modeTypes.SET_MODE,
        modeTypes.MODE_DRAW
      );
      this.init();
    },
    nextSlide() {
      this.cancelTween();
      this.slide = this.slide + 1;
    },
    skip() {
      this.cancelTween();
      this.next();
    },
    ignoreTouch(e) {
      e.preventDefault();
    },
    showPinch() {
      spanAnim(".tutorialSlide__text--1 > span", 0.5);
      this.nextOK2 = false;
      const defaultScale = this.$store.state.canvas.defaultScale;

      let delay = 1.2;
      const animTime = 1.2;
      const scaledVal = defaultScale + 1.7;
      // 拡大
      animScale(
        defaultScale,
        scaledVal,
        animTime,
        delay,
        Expo.easeInOut,
        () => {
          this.scaleFigLarge = true;
        }
      );

      // 縮小
      delay += animTime + 0.3;
      animScale(
        scaledVal,
        defaultScale,
        animTime,
        delay,
        Expo.easeInOut,
        () => {
          this.scaleFigLarge = false;
        }
      );

      setTimeout(() => {
        this.nextOK2 = true;
      }, (delay + 1) * 1000);
    },
    cancelTween() {
      TweenMax.killAll(true);
    },
    showScroll() {
      spanAnim(".tutorialSlide__text--2 > span", 0.0);

      this.nextOK2 = false;
      const el = this.$refs.figScroll;
      const duration = 0.7;
      let delay = 0.5;
      let delayInterval = 0.86;
      const originX = this.offset.x;
      const originY = this.offset.y;
      const ease = Power2.easeInOut;

      const elMove = 100;
      const offsetMove = 50;
      // 左へ
      TweenMax.fromTo(
        el,
        duration,
        { x: 0 },
        { x: -elMove, ease: ease, delay: delay }
      );
      animOffset(
        this.offset,
        { x: this.offset.x + offsetMove, y: originY },
        duration,
        delay,
        ease
      );

      //右へ
      delay += delayInterval;
      TweenMax.to(el, duration, { x: elMove, ease: ease, delay: delay });
      animOffset(
        this.offset,
        { x: this.offset.x - offsetMove, y: originY },
        duration,
        delay,
        ease
      );

      //中央に戻る
      delay += delayInterval;
      TweenMax.to(el, duration, {
        x: 0,
        ease: ease,
        delay: delay,
        onComplete: () => {
          this.nextOK2 = true;
        }
      });
      animOffset(
        this.offset,
        { x: originX, y: originY },
        duration,
        delay,
        ease
      );
    },
    showTools() {
      spanAnim(".tutorialSlide__text--start > span", 0.3);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/colors"
@import "../../sass/common"
.tutorial__click
  @include fit
  position: absolute
  z-index: $z_tutorial_click
  //background-color: rgba(0, 0, 0, 0.5)
  cursor: pointer
#tutorialUI
  position: absolute
  @include fit()
  z-index: $z_tutorial
  color: white


  .tutorial__bg
    background: rgba(0, 0, 0, 0.5)
    position: absolute
    @include fit()
    pointer-events: all
  .tutorial__body
    position: absolute
    @include fit()
  .tutorialSlide
    font-size: 20px
    @include vw(20)
    @include bold
    position: absolute
    @include fit()
    @include flexCenter()
    flex-wrap: wrap
    flex-direction: column
    /*pointer-events: none*/
    text-align: center
  .tutorialSlide__text
    width: 100%

  .tutorialSlide__next
    pointer-events: all
    width: 80px
    font-size: 16px
    &.hide
      visibility: hidden
      pointer-events: none
  .tutorialSlide__scaleFig
    background: url("/img/ui/tutorial/zoom.png") no-repeat 2px 0
    width: 84px
    height: 104px
    background-size: 172px 104px
    &.tutorialSlide__scaleFig--2
      background-position: -89.5px 0
  .tutorialSlide__text--start
    position: absolute
  .tutorialSlide__figure
    margin: 35px 0
    height: 104px
    img
      transform: scale(0.5)
      margin-top: -52px
  .tutorial__skip
    position: absolute
    bottom: 35px
    right: 30px
    text-decoration: underline
    letter-spacing: 0.1em
    z-index: $z_tutorial_click
.tutorialDmyOK
  position: absolute
  width: 100%
  top: 17px
  .tutorialDmyOK__button
    position: absolute
    right: 15px
  .tutorialDmyOK__fukidashi
    position: absolute
    right: 8px
    top: 39px
    img
      width: 90px


.tutorialTitle
  position: absolute
  top: 25px
  width: 100%
  text-align: center
.tutorialStepper
  position: absolute
  top: 82px
  width: 100%
  @include flexCenter
  .tutorialStepper__line
    width: 17px
    height: 2px
    background-color: #ffffff
    margin: 0 5px
  .tutorialStepper__step
    @include bold
    width: 30px
    height: 30px
    border-radius: 30px
    background: $button_bg--dark
    border: 2px solid #ffffff
    @include flexCenter
    @include flexVertical
    font-size: 12px
    line-height: 0
    &.current
      background-color: $primary-button_bg

.fadeUp-enter-active .tutorialDmyOK__fukidashi
    transition: all .09s cubic-bezier(.02,.53,.15,1)
.fadeUp-leave-active .tutorialDmyOK__fukidashi
    transition: all .0s ease-out
.fadeUp-enter .tutorialDmyOK__fukidashi, .fadeUp-leave-to .tutorialDmyOK__fukidashi
    opacity: 0
.fadeUp-enter .tutorialDmyOK__fukidashi
    transform: translateY(14px)
</style>
